import { useCallback, useEffect, useState } from "react";
import type {
  JobDto,
  MaterialDto,
  PurchaseOrderDto,
  StockLocationDto,
  SupplierDto,
} from "@grizzly/shared";
import { api } from "./api.js";
import type { ApiClientError } from "./http.js";

export interface PurchasingData {
  suppliers: SupplierDto[];
  orders: PurchaseOrderDto[];
  jobs: JobDto[];
  materials: MaterialDto[];
  locations: StockLocationDto[];
  error: string | null;
  reload(): void;
}

export function usePurchasingData(): PurchasingData {
  const [suppliers, setSuppliers] = useState<SupplierDto[]>([]);
  const [orders, setOrders] = useState<PurchaseOrderDto[]>([]);
  const [jobs, setJobs] = useState<JobDto[]>([]);
  const [materials, setMaterials] = useState<MaterialDto[]>([]);
  const [locations, setLocations] = useState<StockLocationDto[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const [s, o, j, m, l] = await Promise.all([
        api.listSuppliers(),
        api.listPurchaseOrders(),
        api.listJobs(),
        api.listMaterials(),
        api.listStockLocations(),
      ]);
      setSuppliers(s.items);
      setOrders(o.items);
      setJobs(j.items);
      setMaterials(m.items);
      setLocations(l.items);
      setError(null);
    } catch (err) {
      setError((err as ApiClientError).message);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    suppliers,
    orders,
    jobs,
    materials,
    locations,
    error,
    reload: () => void load(),
  };
}
